/* eslint-disable class-methods-use-this */
import {isMobile} from 'Utils/deviceUtils';
import {guessClickType, guessLabel, runDispatchEvent} from './AnalyticsManager.infra';

/**
 *  @description AnalyticsManager build and send a event some attribute for analytics.
 */
export default class AnalyticsManager {
    /**
     * @description Element that will trigger the sendTag event.
     * @param {HTMLElement} domElement - Element that will trigger the event.
     */
    constructor(domElement) {
        this.domElement = domElement;
        this.isRegistered = false;
        this._trackedElementCount = 0;

        this.initialize();
    }

    /**
     * @description Init the Analytics Manager register it if not.
     */
    initialize() {
        if(!this.isRegistered) {
            this.refresh();
        }

        this.isRegistered = true;
    }

    /**
     * @description Function that will be attached on click event.
     * @param {Event} event - Will be use to locate the target.
     */
    handleClick(event) {
        const target = event.currentTarget;
        const clickType = guessClickType(target);
        const label = guessLabel(target);

        runDispatchEvent({clickType, label});
    }

    /**
     * @description Get the value of the first selected element on select.
     * @param {event} event - It will get target from the event.
     */
    handleChange(event) {
        const target = event.currentTarget;
        const index = target.selectedIndex;
        const optionElement = target.children[index];
        const clickType = guessClickType(optionElement);
        const label = guessLabel(optionElement);

        runDispatchEvent({clickType, label});
    }

    /**
     * @description Register the click on the dom element.
     * @param {HTMLElement} domElement - Element that will be registered for click.
     * @returns {undefined} Short circuit.
     */
    // eslint-disable-next-line complexity,consistent-return
    registerClick(domElement) {
        const mobile = isMobile();
        const method = mobile ? 'touchstart' : 'click';
        if(domElement.dataset.analyticsMobileOnly && !mobile) {
            return;
        }

        if(domElement && !domElement.isAnalyticsRegistered) {
            domElement.addEventListener(method, this.handleClick.bind(this), {passive: mobile});

            domElement.isAnalyticsRegistered = true;
            domElement.dataset.analyticsRegistered = 'true';
        }
    }

    /**
     * @description Register the event for the select.
     * @param {HTMLElement} domElement - Element to register.
     */
    registerSelect(domElement) {
        const mobile = isMobile();

        if(domElement.dataset.analyticsMobileOnly && !mobile) {
            return;
        }

        if(domElement && !domElement.isAnalyticsRegistered) {
            domElement.addEventListener('change', this.handleChange.bind(this), {passive: mobile});

            domElement.isAnalyticsRegistered = true;
            domElement.dataset.analyticsRegistered = 'true';
        }
    }

    /**
     * @description Register the good type of event.
     * @param {HTMLElement} domElement - Element to check and as parameter.
     */
    register(domElement) {
        if(domElement.tagName === 'SELECT') {
            this.registerSelect(domElement);
        } else {
            this.registerClick(domElement);
        }
    }

    /**
     * @description Register the component if necessary.
     * @returns {undefined} True for test.
     */
    // eslint-disable-next-line complexity,consistent-return
    refresh() {
        if(this.domElement.tagName === 'OPTION') {
            return;
        }

        const isRegistered = this.domElement.isAnalyticsRegistered;
        const shouldSendAnalytics = !this.domElement.dataset.analyticsEnabled || this.domElement.dataset.analyticsEnabled === 'true';

        if(!isRegistered && shouldSendAnalytics) {
            this.register(this.domElement);
        } else {
            this.domElement.isAnalyticsRegistered = false;
            this.domElement.dataset.analyticsRegistered = 'false';
        }

        if(!isRegistered) {
            this._trackedElementCount++;
        }
    }
}
